
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
  <path
    d="M4.76998 11H5.83C6.18333 11 6.35999 10.8528 6.35999 10.5583V0.841671C6.35999 0.547224 6.18333 0.400001 5.83 0.400001H4.76998C4.41665 0.400001 4.23999 0.547224 4.23999 0.841671V10.5583C4.23999 10.8528 4.41665 11 4.76998 11Z"
    fill="currentColor"
  />
  <path
    d="M10.6 6.22977V5.16976C10.6 4.81643 10.4528 4.63977 10.1583 4.63977H0.44167C0.147223 4.63977 0 4.81643 0 5.16976V6.22977C0 6.5831 0.147223 6.75977 0.44167 6.75977H10.1583C10.4528 6.75977 10.6 6.5831 10.6 6.22977Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Plus',
    }) as DefineComponent
    </script>
    